/* eslint-disable no-unused-vars */
// 入参配置页面
import { message, Form } from 'antd';
import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import classnames from 'classnames';
import { useEffect, useCallback } from 'react';
// import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import SearchGroup from './components/search_group/SearchGroup';
import { history } from 'umi';
import { handleFormData } from '../../../../utils/breUtils';

const MemberManagement = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['dgic/getNodeInputItemTable'];
  let datas = useSelector((state) => state.dgic.getNodeInputItemTable);

  //选择多个table
  const onSelect = () => {
    // setIdArr(val);
  };
  // 获取会员列表
  const fetchData = useCallback(() => {
    dispatch({
      type: 'dgic/getNodeInputItemTable',
      payload: {
        values: {
          nodeId: history.location.query.nodeId,
        },
      },
    });
  }, [dispatch]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const pushLog = (e) => {
    history.push({
      pathname: '/bre/dgm/dgm/dgmp/dgcl',
      query: {
        nodeId: history.location.query.nodeId,
      },
    });
  };

  const save = () => {
    const oldData = JSON.parse(JSON.stringify(datas));
    const formVal = form.getFieldsValue();
    const newdata = handleFormData(oldData, formVal);

    // 保存接口
    dispatch({
      type: 'dgic/saveGraphTable',
      payload: {
        values: {
          nodeId: history.location.query.nodeId,
          nodeInputItems: newdata,
        },
      },
      callback: (d) => {
        const { code } = d || {};
        if (code) {
          message.error('保存失败');
        } else {
          message.success('保存成功');
        }
        fetchData();
      },
    });
  };

  const cancel = () => {
    fetchData();
  };

  let tableData = datas || [];

  return (
    <div className={styles.mm_content}>
      <Form form={form} name="dgic">
        <div
          className={classnames(styles.search_group, styles.single_component1)}
        >
          <SearchGroup pushLog={pushLog} onCancel={cancel} save={save} />
        </div>
        <p className={styles.nodeName}>
          节点名称：{decodeURIComponent(history.location.query.nodeName)}
        </p>
        <div className={classnames(styles.table_page, styles.single_component)}>
          {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
          <TablePage
            loading={loading}
            tableData={tableData}
            loadingstatus={loading}
            form={form}
          />
        </div>
      </Form>
    </div>
  );
};

export default MemberManagement;
